const Forms = [
    {
        type: 'Input',
        label: 'Name',
        class: 'col-md-6',
        placeHolder: '',
        name: 'Name',
        id: 'Name',
        style : {},
        required : true,
        show : true
    },
    {
        type: 'Select',
        options: 'DOC-CATEGORIES',
        label: 'Category',
        class: 'col-md-6',
        name: 'CategoryId',
        id: 'CategoryId',
        datatype : 'select',
        required : true,
        show : true

    },

   
]

export default Forms